import { Drawer, useMediaQuery, useTheme } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Loader } from '../../../../../components/UtilitySlideout/subComponents'
import {
  ParameterDetailsActions,
  ParameterDetailsSelector,
} from '../../../../../store/parameterDetails'

import { ParameterDrawerDetail } from './ParameterDrawerDetail'

interface ParameterDrawerProps {
  open: boolean
  onClose: () => void
}

export const ParameterDrawer = ({ open, onClose }: ParameterDrawerProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const selectedParameter = useSelector(ParameterDetailsSelector.selectSelectedParameter)
  const dispatch = useDispatch()
  const parameterDetails = useSelector(ParameterDetailsSelector.selectParameterDetailsState)
  const loading = useSelector(ParameterDetailsSelector.loading)

  useEffect(() => {
    if (open && selectedParameter?.name) {
      if (selectedParameter?.name) {
        dispatch(ParameterDetailsActions.fetchParameterDetailsAsync(selectedParameter.name) as any)
      }
    }

    return () => {
      if (!open) {
        dispatch(ParameterDetailsActions.resetParameterDetails())
      }
    }
  }, [open, selectedParameter?.name, dispatch])



  return (
    <Drawer
      anchor={isMobile ? 'bottom' : 'right'}
      open={open}
      onClose={onClose}

      PaperProps={{
        sx: {
          width: isMobile ? '100%' : 560,
         // display: 'flex',
         // flexDirection: 'column',
          height: isMobile ? '90%' : '100%',
          minHeight: isMobile ? '90%' : '100%',
          borderTopLeftRadius: isMobile ? '24px' : 0,
          borderTopRightRadius: isMobile ? '24px' : 0,
         overflowY: 'unset'
        },
      }}
    >
      {loading && <Loader size="large" />}
      {!loading && parameterDetails && selectedParameter && <ParameterDrawerDetail onClose={onClose}/>}


    </Drawer>
  )
}
